import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import determinarPaginaAtual from '../../actions/prestador/determinarPaginaAtualPrestador'
import alterarRegistrosPorPagina from '../../actions/prestador/alterarRegistrosPorPaginaPrestador'

export class PaginacaoPrestador extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    determinarPaginaAtual,
    alterarRegistrosPorPagina
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualPrestador,
    total: state.prestadores.total,
    registrosPorPagina: state.registrosPorPaginaPrestador
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoPrestador)
